import { Box, Column, LineClamp, Text } from '~/commonComponents';
import { IColumnDef } from '~/commonComponents/DataGrid';
import { InviteProfessional } from '~/commonComponents/InviteProfessional';
import { IDashboardJob } from '~/domain/DashboardJobs';
import { UserSubProfession } from '~/enums/UserProfession';
import { ArrowRightIcon } from '~/images/icons';
import { Colors } from '~/themes/colors';

type TDataGridCommonColumn = {
  Action: IColumnDef<IDashboardJob>;
  Details: IColumnDef<IDashboardJob>;
  Invite: IColumnDef<IDashboardJob>;
  Office: IColumnDef<IDashboardJob>;
  Profession: IColumnDef<IDashboardJob>;
  Rate: IColumnDef<IDashboardJob>;
  Type: IColumnDef<IDashboardJob>;
};

export const DataGridCommonColumn: TDataGridCommonColumn = {
  Action: {
    key: 'action',
    header: '',
    width: '50px',
    align: 'center',
    render: () => <ArrowRightIcon />,
  },
  Details: {
    key: 'details',
    header: 'Details',
    width: '192px',
    render: (item) => (
      <Column gap={4}>
        <Text bold>{item.date}</Text>
        <Text color="neutral_500">
          {item.startTime} - {item.endTime}
        </Text>
      </Column>
    ),
  },
  Invite: {
    key: 'invite',
    header: 'Invite',
    width: '80px',
    align: 'center',
    render: (item) => {
      if (item.dashboardJobApi.isOnsiteInterview) {
        return null;
      }

      return <InviteProfessional shift={item.dashboardJobApi} size="icon" />;
    },
  },
  Office: {
    key: 'office',
    header: 'Office',
    width: '1fr',
    render: (item) => (
      <LineClamp lineClamp={2} text={item.office.name} style={{ color: Colors.neutral_600 }} />
    ),
  },
  Profession: {
    key: 'profession',
    header: 'Profession',
    width: '192px',
    render: (item) => (
      <Column gap={4}>
        <Text bold>
          {UserSubProfession.getName(item.subProfession ?? '') ?? item.professionName}
        </Text>
        <Text color="neutral_500">{item.specialty?.split('_')?.[1] ?? 'General'}</Text>
      </Column>
    ),
  },
  Rate: {
    key: 'rate',
    header: (
      <Text bold color={Colors.primary_500} fontSize={18} paddingLeft={24}>
        Rate
      </Text>
    ),
    width: '100px',
    render: (item) => (
      <Text bold paddingLeft={24}>
        ${item.rate.toFixed(2)}
      </Text>
    ),
  },
  Type: {
    key: 'type',
    header: (
      <Text bold color={Colors.primary_500} fontSize={18} paddingLeft={16}>
        Type
      </Text>
    ),
    width: '120px',
    render: (item) => (
      <Box
        alignSelf="flex-start"
        paddingVertical={2}
        paddingHorizontal={10}
        borderRadius={8}
        backgroundColor={
          item.dashboardJobApi.isOnsiteInterview
            ? Colors.jobs_interview_background
            : Colors.jobs_shift_background
        }
      >
        <Text color="neutral_500">
          {item.dashboardJobApi.isOnsiteInterview ? 'INTERVIEW' : 'SHIFT'}
        </Text>
      </Box>
    ),
  },
};
